var React = require('react');

function Instagram (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"2","y":"2","width":"20","height":"20","rx":"5","ry":"5","key":0}),React.createElement("path",{"d":"M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z","key":1}),React.createElement("line",{"x1":"17.5","y1":"6.5","x2":"17.5","y2":"6.5","key":2})]);
}

Instagram.defaultProps = {"width":"44","height":"44","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-instagram"};

module.exports = Instagram;

Instagram.default = Instagram;
